import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ApiResponse, Payee, PayeeData, PayeeList } from '../../data/system/Payee';

@Injectable()
export class PayeeService extends PayeeData {

  constructor(private http: HttpClient) { super(); }

  get(params: Payee): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.payee_get}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`payee->get->data`, data))
    );
  }

  savePayee(params: PayeeList): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.payee_save}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`payee->get->data`, data))
    );
  }

  getPayeeById(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.payee_get_by_id.replace(':id', id)}`;
    return this.http.get<ApiResponse>(host).pipe(
      tap(data => console.log(`payee->get->data`, data))
    );
  }

}
